// Material UI
import {Link, Typography} from '@mui/material';

import {AppConfig} from '../../lib/AppConfig';

export default function Copyright(props: any) {
  return (
    <Typography variant='body1' color='black' align='center' {...props}>
      {'Copyright © '}
      <Link color='inherit' href={AppConfig.WEBSITE_BASE_URL}>
        Empion GmbH
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
